import React, {useState} from "react";
import "./parkingSlotsInfo.scss";
import IconButton from "../../../../baseApp/shared/components/others/IconButton";
import arrowDown from "../../../../baseApp/shared/img/arrow-down.svg";
import {I18n} from "react-redux-i18n";
import {Accordion, AccordionDetails, AccordionSummary} from "@material-ui/core";

const ParkingSlotsInfo = ({categoriesData, totalSlotsData}) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <Accordion expanded={expanded} className="parking-occupancy-expansion-panel">
            <AccordionSummary
                id={"ParkingSlotsInfo-d-header"}
                aria-controls={"ParkingSlotsInfo-d-content"}
                expandIcon={
                    <IconButton
                        alt="delete"
                        image={arrowDown}
                        handleIconClick={() => setExpanded(!expanded)}
                    />
                }
            >
                <div className="slots-info-totals-wrapper">
                    <div className="slots-info-item">
                        <div className="slots-info-item-description">
                            {I18n.t('parking.page.slotInfo.category')}
                        </div>
                        <div className="slots-info-item-value" style={{ alignItems: "center" }}>
                                <span className="slots-info-item-value-units" style={{ fontSize: "1.75rem" }}>
                                    {I18n.t('parking.page.slotInfo.allCategories')}
                                </span>
                        </div>
                    </div>
                    <div className="slots-info-item">
                        <div className="slots-info-item-description">{I18n.t('parking.page.slotInfo.parkingSlots')}</div>
                        <div className="slots-info-item-value">
                            <span className="slots-info-item-value-quantity">{totalSlotsData.parkingSlots}</span>
                            <span className="slots-info-item-value-units">{I18n.t('parking.page.slotInfo.total')}</span>
                        </div>
                    </div>
                    <div className="slots-info-item">
                        <div className="slots-info-item-description">
                            {I18n.t('parking.page.slotInfo.freeSlots')}
                        </div>
                        <div className="slots-info-item-value">
                            <span className="slots-info-item-value-quantity">{totalSlotsData.freeSlots}</span>
                            <span className="slots-info-item-value-units">
                                    {I18n.t('parking.status.free')}
                                </span>
                        </div>
                    </div>
                    <div className="slots-info-item">
                        <div className="slots-info-item-description">{I18n.t('parking.page.slotInfo.occupiedSlots')}</div>
                        <div className="slots-info-item-value">
                            <span className="slots-info-item-value-quantity">{totalSlotsData.occupiedSlots}</span>
                            <span className="slots-info-item-value-units">{I18n.t('parking.status.occupied')}</span>
                        </div>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails className="parking-occupancy-expansion-panel-details">
                {
                    expanded && categoriesData.map((category, idx) =>
                        <div key={"category_" + idx} className="slots-info-wrapper">
                            <div className="slots-info-item">
                                <div className="slots-info-item-value">
                                        <span className="slots-info-item-value-units font-weight-bold">
                                            {category.name}
                                        </span>
                                </div>
                            </div>
                            <div className="slots-info-item">
                                <div className="slots-info-item-value">
                                    <span className="slots-info-item-value-quantity">{category.parkingSlots}</span>
                                    <span className="slots-info-item-value-units">{I18n.t('parking.page.slotInfo.total')}</span>
                                </div>
                            </div>
                            <div className="slots-info-item">
                                <div className="slots-info-item-value">
                                    <span className="slots-info-item-value-quantity">{category.freeSlots}</span>
                                    <span className="slots-info-item-value-units">
                                    {I18n.t('parking.status.free')}
                                </span>
                                </div>
                            </div>
                            <div className="slots-info-item">
                                <div className="slots-info-item-value">
                                    <span className="slots-info-item-value-quantity">{category.occupiedSlots}</span>
                                    <span className="slots-info-item-value-units">{I18n.t('parking.status.occupied')}</span>
                                </div>
                            </div>
                        </div>
                    )
                }
            </AccordionDetails>
        </Accordion>
    );
};

export default ParkingSlotsInfo;